var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._g(_vm._b({staticClass:"ml-4",on:{"click":_vm.action}},'v-btn',_vm.$attrs,false),_vm.parentOn),[(_vm.icon)?_c('v-icon',{attrs:{"left":_vm.$attrs.fab === undefined}},[_vm._v(" "+_vm._s(_vm.icon)+" ")]):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.btnValue))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }